import mimeDb from '@shared/constants/mimeDb';

export const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

type MimeWithExtensions = {
  [K in keyof typeof mimeDb]: (typeof mimeDb)[K] extends { extensions: string[] } ? K : never;
}[keyof typeof mimeDb];

export type MimeToExtensions = {
  [K in MimeWithExtensions]?: string[];
};

// Create a hash based on key to list of mime types
export const mimeGroups: {
  cad: MimeWithExtensions[];
  document: MimeWithExtensions[];
  images: MimeWithExtensions[];
  pdf: MimeWithExtensions[];
  presentation: MimeWithExtensions[];
  spreadsheet: MimeWithExtensions[];
  zip: MimeWithExtensions[];
} = {
  cad: [
    'application/acad',
    'image/x-dwg',
    'application/vnd.dwg',
    'application/dwg',
    'application/x-dwg',
    'drawing/dwg',
    'image/vnd.dwg',
  ],
  document: [
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.oasis.opendocument.text',
    'application/rtf',
    'application/vnd.ms-works',
    'application/vnd.ms-xpsdocument',
  ],
  images: ['image/jpeg', 'image/png'],
  pdf: ['application/pdf'],
  presentation: [
    'application/vnd.ms-powerpoint',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
  ],
  spreadsheet: [
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'text/csv',
    'application/vnd.oasis.opendocument.spreadsheet',
    'application/vnd.ms-excel.addin.macroenabled.12',
    'application/vnd.ms-excel.sheet.binary.macroenabled.12',
    'application/vnd.ms-excel.sheet.macroenabled.12',
  ],
  zip: ['application/zip'],
};

export enum ContainerWidths {
  xxs = 320,
  xs = 384,
  sm = 480,
  md = 560,
  lg = 640,
  xl = 768,
  xl2 = 1024,
  xl3 = 1280,
  xl4 = 1440,
  xl5 = 1600,
  xl6 = 1920,
  auto = 'auto',
  full = '100%',
  // Custom - do not use if possible
  custom820 = 820,
  columnPicker = 900,
  custom1152 = 1152,
}

// URL validation regex
export const urlRegex =
  /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z0-9\u00a1-\uffff][a-z0-9\u00a1-\uffff_-]{0,62})?[a-z0-9\u00a1-\uffff]\.)+(?:[a-z\u00a1-\uffff]{2,}\.?))(?::\d{2,5})?(?:[/?#]\S*)?$/i;
